<template>
	<div class="body">
		<div class="body-container">
			<div class="expert-container" v-if="expert">
				<div class="boder-box">
					<img class="expert-img" :src="expert.images" />
					<div class="expert-infos">
						<div class="expert-name">{{ expert.name }}</div>
						<img class="underline" src="../assets/icons/title_underline.png" />
						<div class="expert-intro">{{ expert.intro }}</div>
					</div>
				</div>
			</div>
			<div class="video-container">
				<div class="container-title">精彩讲座</div>
				<div class="video-row" v-for="(item, index) in videoList" :key="index" @click="clickRoute(item)">
					<img class="play-icon" src="../assets/icons/play.png" />
					<div class="video-title">{{ item.name }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getAuthorPage
	} from "@/api/voice"

	import {
		handleProtocal
	} from "@/utils/protocal"


	export default {
		name: "Expert",
		data() {
			return {
				expert: undefined,
				videoList: [],
				queryParams: {
					id: undefined,
					page: 1
				}
			}
		},
		created() {
			this.queryParams.id = this.$route.params.id;
			this.initPageData();
		},
		methods: {
			initPageData() {
				getAuthorPage(this.queryParams).then(res => {
					this.expert = res.data.author;
					this.videoList = res.data.list;
				});
			},

			clickRoute(item) {
				handleProtocal(item.url)
			}
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "expert.scss";
</style>